import {State} from './state'

export class Seat {
  id: string;
  name: string;
  state: State;

  constructor(id: string, name: string, state: State) {
    this.id = id;
    this.name = name;
    this.state = state;
  }
}
